import { createEventBus } from "@shared/features/eventBus/createEventBus";
import { QuizQuestionAnswer } from "@platform/types/quiz.types";

export type QuizEvents = {
  "quiz:started": { quizId: string };

  "quiz:answer:submitted": {
    questionId: number;
    answer: QuizQuestionAnswer;
    quizId: number;
    responseId: number;
  };

  "quiz:completed": { quizId: number; invitationId: number };
};

export const quizEventBus = createEventBus<QuizEvents>();

export default QuizEvents;
